import pixnft from "../../Assets/pixnft.jpg";
import "../../Styles/CommunityStyles/pixnft.css";
import nftTower from '../../Assets/13818793_5318526.jpg'
import nftWorld from '../../Assets/13961186_5394659.jpg'
import nftCompass from '../../Assets/13862473_5378858.jpg'

import React from 'react'

export default function Pixnft() {
  return (
    <div className="Pix">
       <div className="pixnftContainer">

        <div className="pixLeft">
        <div className="pixHead">pixnft</div>
          <div className="subhead">THE NFT COMMUNITY OF NFTOWN APPLICATION</div>
          <div className="pixtext">
            PixNFT has the total supply of 500 NFTs and 278 NFTs mined.
            <br />
            Purchase the NFT to join our NFT community and get gas fees of
            <br />
            NFTOWN application.
          </div>
        </div>
        <div className="pixRight">
          <div className="img_tiels">
          <div className="pix_img">
              <img src={nftTower} alt="" className="pixImg"/>
            </div>
            <div className="pix_img">
              <img src={nftWorld} alt="" className="pixImg" />
            </div>
            <div className="pix_img">
              <img src={nftCompass} alt="" className="pixImg"/>
            </div>
          </div>
        </div>
       </div>

    </div>
  )
}
